import api from ".";
import generateHeaders from "../utils/generateHeaders";

export const getDefaultersDataService = async ({ token }) => {
  const options = generateHeaders(token);
  return await api.get(`/accounts-receivable/debtors`, options);
};

export const verifyDefaulterService = async ({ token, contractNumber }) => {
  const options = generateHeaders(token);
  return await api.get(
    `/accounts-receivable/debtors/?contractNumber=${contractNumber}`,
    options
  );
};
